// PaymentAcknowledgement.js
import {
  Box,
  Button,
  Paper,
  Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PlanningAndZoningAcknowledgement = ({
  applicationDetails,
  totalAmountPayable,
  totalAmountWithoutTax,
  totalTaxAmount,
  applicationNumber,
  basePath
}) => {
  const navigate = useNavigate();
  return (
    <Paper sx={{ borderRadius: 2, boxShadow: 3 }}>
      <Typography variant="h4" sx={{ mb: 2, textAlign: 'center' }}>
        Payment Acknowledgement
      </Typography>
      <Typography>
        Hello <strong>{applicationDetails?.userName}</strong>,
      </Typography>

      <>
        <Typography sx={{ mt: 1 }}>
          Your payment of <strong>${totalAmountPayable} </strong>
          for Application <strong>#{applicationNumber} </strong>
          has been received, including <strong>
            ${totalAmountWithoutTax}
          </strong>{' '}
          for the
          {applicationDetails?.permitPrefix === 'P'
            ? ' Planning'
            : ' Zoning'}{' '}
          application and
          <strong> ${totalTaxAmount}</strong> for online convenience fees.
        </Typography>
        <Typography sx={{ mt: 1 }}>
          Please return to our website and upload your completed & signed W9
          form. Your application processing will be delayed until this is
          complete.
        </Typography>
        <Typography sx={{ mt: 0 }}>
          Please visit our <a href="_">website</a> to get details on next steps.
        </Typography>
      </>

      <Typography sx={{ mt: 1 }}>
        If you have any further questions, please contact us at{' '}
        <a href={`mailto:${'PlanningZoningWebsiteApplications'}@techgov.com`}>
          {'PlanningZoningWebsiteApplications'}@techgov.com
        </a>
        .
      </Typography>
      <br />
      <Typography sx={{ mt: 1 }}>
        Thank you, <br />
        Planning and Zoning Dept.
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, gap: 2 }}>
        <Button
          variant="outlined"
          onClick={() => navigate(`${basePath}/application-list`)}
        >
          View My Applications
        </Button>
      </Box>
    </Paper>
  );
};

export default PlanningAndZoningAcknowledgement;
